import { isUndefined } from 'lodash';

const formatErrorMessage = (error: any) => {
  if (isUndefined(error) || isUndefined(error.response)) {
    return undefined;
  }
  if (error.response.status !== 404) {
    const errorMessage = error.response.data.message;
    const messageFormaterd = errorMessage.substring(
      errorMessage.indexOf('["') + 2,
      errorMessage.lastIndexOf('"]'),
    );
    return messageFormaterd;
  } else {
    return error.response.data.message;
  }
};

export const formatErrorMessageAsString = (errorString: string) => {
  return errorString?.substring(errorString.indexOf(']: [') + 6, errorString.lastIndexOf('"]') - 1);
};
export default formatErrorMessage;
